export default function RightArrowIcon() {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7548 6.09996L6.92719 1.27236L8.19979 -0.000244141L15.2 6.99996L8.19979 14.0002L6.92719 12.7276L11.7548 7.89996H0.799988V6.09996H11.7548Z"
        fill="white"
        fillOpacity="0.2"
      />
    </svg>
  );
}
